import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const MortgageModuleVariantName = z.enum([
  'prmg',
  'encompass_lending_group',
  'lakeview',
  'alcova',
  'carrington',
  'default',
])

export type MortgageModuleVariantName = z.infer<typeof MortgageModuleVariantName>

export const MortgageModuleVariantSchema = z.object(
  {
    title: z.string(),
    partner_name: z.string().optional(),
    card_name: z.string().optional(),
    description: z.string(),
    action_text: z.string(),
    action_url: z.string().optional(),
    image_url: z.string().optional(),
    details_paragraphs: z.array(z.string()).optional(),
    disclosure_paragraphs: z.array(z.string()).optional(),
  },
  {
    message: 'MortgageModuleVariantSchema must be a valid object',
  },
)

export const MortgageModuleDetailsSchema = z.object({
  default: MortgageModuleVariantSchema,
  prmg: MortgageModuleVariantSchema,
  encompass_lending_group: MortgageModuleVariantSchema,
  lakeview: MortgageModuleVariantSchema,
  alcova: MortgageModuleVariantSchema,
  carrington: MortgageModuleVariantSchema,
})

export type MortgageModuleDetailsSchema = z.infer<typeof MortgageModuleDetailsSchema>

export const MortgageModuleStateSchema = z.object(
  {
    name: z.string(),
    image: z.string(),
    thumbhash: z.string(),
    enableHomeSection: z.boolean().optional().default(false),
    enableScheduleACall: z.boolean().optional().default(false),
    enableInAppLeadForm: z.boolean().optional().default(false),
  },
  {
    message: 'MortgageModuleStateSchema must be a valid object',
  },
)
export type MortgageModuleState = z.infer<typeof MortgageModuleStateSchema>

export const MesaMortgageModuleSchema = z.object({
  module_details: MortgageModuleDetailsSchema,
  states: z.record(z.string(), MortgageModuleStateSchema),
})

export type MortgageModule = z.infer<typeof MesaMortgageModuleSchema>

export function useMortgageModuleParameterStore() {
  return useMesaParameterStore('mesa_mortgage_module')
}
